<template>
  <div>
    <base-wrapper :loading="loading">
      <div class="space-y-4">
        <shipment-card label="Restock" :stock-movement="stockMovement" />

        <base-card
          title="Informasi Kemasan"
          description="Daftar kemasan yang akan dikirim ke Stockist Center"
        >
          <div class="grid grid-cols-3 gap-6 border-t pt-5">
            <base-input
              class="col-span-full"
              inset
              disabled
              label="Nama Kemasan"
              :value="stockMovement.data.attributes.code"
            />

            <datatable class="col-span-full" :columns="packetColumns">
              <template #tbody="{ classes }">
                <tr
                  v-for="packet in getIncludedByType(stockMovement, 'packets')"
                  :key="packet.uuid"
                  :class="[classes.tr]"
                >
                  <td :class="[classes.td, 'cursor-pointer']" @click="onClickDetailKoli(packet)">
                    <p class="font-medium text-gray-900">{{ packet.attributes.name }}</p>
                  </td>
                  <td :class="classes.td">
                    <PrintPacket :stock-movement="stockMovement" :order="order" :packet="packet" />
                  </td>
                </tr>
              </template>
            </datatable>
          </div>
        </base-card>

        <base-card
          v-if="
            order?.attributes?.order_shipment === 'delivery'
          "
          title="Pilih ekspedisi"
          description="Pilih ekspedisi pengiriman"
        >
          <base-input inset label="Pilih ekspedisi">
            <select-office-expedition inset v-model="officeExpeditionId" @change="onChangeExpedition" />
          </base-input>
        </base-card>

        <ShipmentReceiptCard
          v-if="stockMovement.data.attributes.is_shipped"
          :order="order"
          v-model="stockMovement"
        />

        <div class="flex justify-between">
          <div class="flex items-center gap-2">
            <base-button
              v-if="canCancel && !stockMovement.data.attributes.is_shipped"
              color="white"
              @click="cancelConfirmationVisible = true"
            >
              <Icon icon="heroicons:x-mark-solid" class="h-4 w-4" />
              Batalkan Faktur Kemasan
            </base-button>
            <PrintOrderSppb v-if="order?.id" :order-id="order.id" />
            <PrintOrderSttb :stock-movement-id="$route.params.id" />
          </div>
          <div class="flex gap-2">
            <base-button
              v-if="!stockMovement.data.attributes.is_shipped"
              @click="sendModalVisible = true"
            >
              <Icon icon="heroicons:truck-solid" class="h-4 w-4" />
              {{ stockMovement.data.attributes.shipment_type === 'pickup' ? 'Ambil' : 'Kirim' }}
            </base-button>
            <base-button color="white" :to="indexPath">
              <Icon icon="heroicons:arrow-uturn-left-solid" class="h-4 w-4" />
              Kembali
            </base-button>
          </div>
        </div>
      </div>

      <view-packet-modal
        :with-complain-form="false"
        :packet="detailKoliModal.packet"
        :visible="detailKoliModal.visible"
        with-batches
        @close="detailKoliModal.visible = false"
      />
      <cancel-shipment-confirmation
        :visible="cancelConfirmationVisible"
        :stock-movement-id="stockMovement.data.id"
        @close="cancelConfirmationVisible = false"
        @confirmed="$router.push(indexPath)"
      />
      <send-stock-movement-modal
        :visible="sendModalVisible"
        :stock-movement="stockMovement"
        @close="sendModalVisible = false"
        @sent="$router.push(indexPath)"
      />
    </base-wrapper>
  </div>
</template>

<script>
import ViewPacketModal from '@/components/stock-movement/view-packet-modal.vue';
import CancelShipmentConfirmation from '@/components/stock-movement/cancel-shipment-confirmation.vue';
import { requestMixin } from '@/mixins/request/request';
import SendStockMovementModal from '@/components/stock-movement/send-stock-movement-modal.vue';
import ShipmentCard from '@/components/shipment/shipment-card.vue';
import SelectOfficeExpedition from '@/components/expedition/select-office-expedition.vue';
import PrintOrderSppb from '@/components/order/PrintOrderSppb.vue'
import PrintOrderSttb from '@/components/order/PrintOrderSttb.vue'
import { mapGetters } from 'vuex'
import PrintPacket from '@/components/stock-movement/PrintPacket.vue';
import ShipmentReceiptCard from '../../../../../components/shipment/shipment-receipt-card.vue';

export default {
  components: {
    ViewPacketModal,
    CancelShipmentConfirmation,
    SelectOfficeExpedition,
    SendStockMovementModal,ShipmentCard,
    PrintOrderSppb,
    PrintOrderSttb,
    PrintPacket,
    ShipmentReceiptCard
  },
  mixins: [requestMixin],
  data() {
    return {
      indexPath: {
        name: 'gudang.pengiriman.barang-ke-kp',
      },
      detailKoliModal: {
        visible: false,
        packet: {},
      },
      cancelConfirmationVisible: false,
      sendModalVisible: false,
      loading: false,
      officeExpeditionId: null,
      stockMovement: {
        data: {
          attributes: {},
          relationships: {
            order: {
              data: {},
            },
            'destination-office': {
              data: {},
            },
          },
        },
        included: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser'
    }),
    canCancel() {
      return this.me.permissions.includes('orders.cancel_warehouse')
    },
    destinationOffice() {
      return this.getSingleIncluded(
        this.stockMovement,
        this.stockMovement.data.relationships['destination-office'].data.id
      );
    },
    order() {
      return this.getSingleIncluded(
        this.stockMovement,
        this.stockMovement.data.relationships.order.data.id
      );
    },
    packetColumns() {
      return [
        {
          id: 'code',
          name: 'Kode Koli',
        },
        {
          id: 'qty',
          name: 'Jumlah Produk',
        },
        {
          id: 'action',
          name: 'Aksi',
        },
      ];
    },
  },
  methods: {
    async loadStockMovement() {
      this.loading = true;

      const [res, err] = await this.request(
        `/api/v1/stock-movements/${this.$route.params.id}`,
        {
          params: {
            include: 'order,destination-office,packets,office-expedition',
            'fields[stock-movements]':
              'code,updatedAt,is_shipped,airwaybill_number,taken_by,packets,office-expedition,order,destination-office,shipment_type',
            'fields[packets]': 'code,name',
            'fields[orders]': 'structured_complete_shipment_address,complete_shipment_address,origin_code,destination_code,order_shipment,is_transfer_promo,is_transfer_promo_regular',
            'fields[offices]': 'code,name,address,address2,phone',
          },
        }
      );

      if (!err) {
        this.stockMovement = res;

        if (res.data.relationships['office-expedition'].data) {
          this.officeExpeditionId = res.data.relationships['office-expedition'].data.id
        }
      }

      this.loading = false;
    },
    onClickDetailKoli(packet) {
      this.detailKoliModal.packet = packet;
      this.detailKoliModal.visible = true;
    },
    async onChangeExpedition() {
      this.loading = true

      await this.request(`/api/v1/stock-movements/${this.stockMovement.data.id}`, {
        method: 'patch',
        data: {
          data: {
            type: 'stock-movements',
            id: this.stockMovement.data.id,
            relationships: {
              'office-expedition': {
                data: !this.officeExpeditionId ? null : {
                  type: 'office-expeditions',
                  id: this.officeExpeditionId
                }
              } 
            }
          }
        }
      })

      this.loading = false
    }
  },
  created() {
    this.loadStockMovement();
  },
};
</script>
